<div
  [id]="id"
  class="flex flex-1 flex-col h-full p-4 border rounded-md"
  [ngClass]="{
    'border-grey-300 bg-blue-50 text-subtle': !chkVoteOptionCtrl.value
  }"
  [ngClass]="{
    'border-blue-400 bg-blue-50 text-black': chkVoteOptionCtrl.value
  }"
>
  <form [formGroup]="voteOptionForm" class="flex flex-col h-full">
    <div class="flex flex-col h-full justify-between gap-4">
      <div class="flex flex-col gap-4">
        <div class="flex flex-row justify-between flex-wrap">
          <div class="flex flex-row gap-2 items-center">
            <h5 [id]="'h5-' + id" class="mb-0 text-black">
              {{ voteOptionClass.text }}
            </h5>
            <span
              class="material-symbols-rounded"
              [style.color]="voteOptionClass.color"
              >{{ voteOptionClass.icon }}
            </span>
          </div>
          <div class="flex items-center cursor-pointer">
            <label class="text-subtle" for="chk-{{ id }}"> Select </label>
            <input
              type="checkbox"
              [id]="'chk-' + id"
              [name]="'chk-' + id"
              [value]="voteOptionId"
              formControlName="chkVoteOptionCtrl"
              class="ml-1"
            />
          </div>
        </div>

        <mat-divider class="border-gray-300"></mat-divider>
        <ng-content></ng-content>
      </div>
      <div class="flex flex-col gap-2">
        <label class="body-small-regular text-subtle" [for]="id + '-comment'"
          >Please enter a reason for your decision</label
        >
        <app-text-area
          [id]="id + '-comment'"
          formControlName="commentCtrl"
          [displayCharactersCount]="false"
          placeholder="Please enter a reason for your decision"
          [rows]="2"
        ></app-text-area>
      </div>
    </div>
  </form>
</div>
